import { Link } from "react-router-dom";
import "@/landing/landing.css";

const DISCLAIMER =
  "KidPath provides general information and support navigation tools. It does not provide medical, clinical, legal, financial, government, or funding eligibility advice. Program details, eligibility rules, and service options may change. Families should confirm details with official sources and qualified professionals.";

export function PublicFooter() {
  return (
    <div className="landing-page">
      <footer data-testid="public-footer">
        <div className="wrap">
          <div className="foot-grid">
            <div className="foot-brand">
              <div className="brand">
                <img src="/assets/kidpath-mark-dark.png" alt="" />
                <span><span className="k">Kid</span><span className="p">Path</span></span>
              </div>
              <p>General information and support-navigation tools for Canadian families navigating autism support.</p>
            </div>
            <div className="foot-col">
              <h4>Product</h4>
              <Link to="/providers">Find a Provider</Link>
              <Link to="/#how">How it works</Link>
              <Link to="/#what">What you get</Link>
              <Link to="/#pricing">Pricing</Link>
              <Link to="/register">Support path</Link>
            </div>
            <div className="foot-col">
              <h4>Resources</h4>
              <Link to="/funding-guide">Free Funding Guide</Link>
              <Link to="/articles">Articles</Link>
              <Link to="/terms">Glossary</Link>
              <Link to="/#faq">Getting started</Link>
              <Link to="/#faq">FAQ</Link>
            </div>
            <div className="foot-col">
              <h4>Company</h4>
              <Link to="/about">About</Link>
              <Link to="/contact">Contact</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms-of-service">Terms</Link>
              <Link to="/terms">Glossary</Link>
            </div>
          </div>
          <div className="foot-bottom">
            <span>© 2026 KidPath · Made in Canada 🍁</span>
            <span>KidPath.ca</span>
          </div>
        </div>
        <p className="disclaimer">{DISCLAIMER}</p>
      </footer>
    </div>
  );
}
